import { Post } from "../utils/http-utils";


export const getUploadedUrl = (requestBody) => {
    return Post("/file-browsing/generate-upload-url", requestBody)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return [];
        });
};


export const uploadFileToMachine = (requestBody) => {
    return Post("/jobs", requestBody)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return [];
        });
};
